module.exports = __webpack_public_path__ + "static/media/imgslider2.9bf86ebc.jpg";